<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-21 14:51:02
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-30 11:11:09
 * @FilePath: /wemeet-admin-new/src/views/recruitment/recommend/RecommenderDetail.vue
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
-->
<template>
  <el-dialog destroy-on-close :model-value="visible" title="查看详情" width="75vw" @close="close" @open="open">
    <div class="recommender-detail wemeet-description">
      <h3>推荐人信息</h3>
      <div v-if="recommenderInfo">
        <el-row>
          <el-col class="is-label" :span="3">用户名</el-col>
          <el-col :span="5">{{ recommenderInfo.name }}</el-col>
          <el-col class="is-label" :span="3">手机号码</el-col>
          <el-col :span="5">{{ recommenderInfo.phone }}</el-col>
          <el-col class="is-label" :span="3">电子邮箱</el-col>
          <el-col :span="5">{{ recommenderInfo.email }}</el-col>
        </el-row>
        <el-row>
          <el-col class="is-label" :span="3">机构</el-col>
          <el-col :span="5">{{ recommenderInfo.company }}</el-col>
          <el-col class="is-label" :span="3">职位</el-col>
          <el-col :span="5">{{ recommenderInfo.position }}</el-col>
          <el-col class="is-label" :span="3">头像</el-col>
          <el-col :span="5">
            <el-image :src="recommenderInfo.avatar" style="width: 80px; height: 80px" />
          </el-col>
        </el-row>
        <el-row>
          <el-col class="is-label" :span="3">地区</el-col>
          <el-col :span="21">{{ recommenderInfo.address || recommenderInfo.country }}</el-col>
        </el-row>
      </div>

      <h3>推荐人才信息</h3>
      <el-form inline @submit.prevent="query">
        <el-form-item label="应聘人姓名">
          <el-input v-model="queryParams.name" clearable placeholder="请输入应聘人姓名" @change="query" />
        </el-form-item>
        <el-form-item label="手机号码">
          <el-input v-model="queryParams.phone" clearable placeholder="请输入手机号码" @change="query" />
        </el-form-item>
        <el-form-item label="岗位名称">
          <el-input v-model="queryParams.jobName" clearable placeholder="请输入岗位名称" @change="query" />
        </el-form-item>
        <el-form-item label="人才状态">
          <el-select v-model="queryParams.talentStatus" clearable placeholder="请选择" @change="query">
            <el-option v-for="item in talentStatusOptions" :key="item.value" v-bind="item" />
          </el-select>
        </el-form-item>
        <el-form-item label="入职时间">
          <el-date-picker
            v-model="queryParams.entryTime"
            end-placeholder="结束时间"
            range-separator="至"
            start-placeholder="开始时间"
            type="daterange"
          />
        </el-form-item>
        <el-form-item>
          <el-button icon="search" type="primary" @click="query">查询</el-button>
          <el-button icon="refresh" type="warning" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- 表格 -->
      <el-table v-loading="loading" border :data="tableData" :max-height="300" :table-layout="'auto'">
        <el-table-column label="应聘人姓名" prop="name" :width="120" />
        <el-table-column label="手机号码" prop="phone" />
        <el-table-column label="人才状态" prop="status" />
        <el-table-column label="应聘机构" prop="enterpriseName" />
        <el-table-column label="岗位名称" prop="jobName" />
        <el-table-column label="岗位类型" prop="category" />
        <el-table-column label="入职时长">
          <template #default="{ row }">
            {{ isNumber(row.entryDays) ? row.entryDays + '天' : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="入职时间" prop="entryTime" />
        <el-table-column label="可提现奖金">
          <template #default="{ row }">
            {{ isNumber(row.rewardAmount) ? row.rewardAmount : '-' }}
          </template>
        </el-table-column>
        <template #empty>
          <el-empty class="vab-data-empty" description="暂无数据" />
        </template>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        v-model:current-page="queryParams.pageNum"
        background
        layout="prev, pager, next"
        :page-size="queryParams.pageSize"
        :total="queryParams.total"
        @current-change="query"
      />
    </div>
    <template #footer>
      <el-button @click="close">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
  import { defineProps, defineEmits, ref, reactive, watchEffect } from 'vue'
  import { isNumber, omit } from 'lodash'
  import { getRecommendDetail } from '@/api/recruitment'
  import { parseTime } from '@/utils'
  import { TALENT_STATUS_CN } from '../context'

  const props = defineProps({
    visible: Boolean,
    recommendCode: String,
  })

  const emit = defineEmits(['close'])

  const loading = ref(false)
  const tableData = ref([])

  const recommenderInfo = ref()

  const defaultQueryParams = {
    name: '',
    phone: '',
    jobName: '',
    entryTime: [],
    entryStartTime: '',
    entryEndTime: '',
    talentStatus: '',
    pageNum: 1,
    pageSize: 20,
    total: 0,
  }

  const queryParams = reactive({ ...defaultQueryParams })

  const talentStatusOptions = Object.entries(TALENT_STATUS_CN).map(([key, value]) => ({
    label: value,
    value: key,
  }))

  watchEffect(() => {
    const [start, end] = queryParams.entryTime
    if (start) queryParams.entryStartTime = parseTime(start, '{y}-{m}-{d}')
    if (end) queryParams.entryEndTime = parseTime(end, '{y}-{m}-{d}')
  })

  function query(reset = false) {
    const params = {
      recommendCode: props.recommendCode,
      ...omit(queryParams, 'total', 'entryTime'),
    }

    if (reset) params.pageNum = 1

    loading.value = true

    getRecommendDetail(params)
      .then(({ code, data }) => {
        if (code !== 200) return
        const { userJobInfoDtoPageInfo, ...info } = data
        const { list, total } = userJobInfoDtoPageInfo
        recommenderInfo.value = info
        tableData.value = list.map((e) => {
          e.entryTime = e.entryTime ? parseTime(e.entryTime, '{y}-{m}-{d}') : '-'
          e.status = e.status ? TALENT_STATUS_CN[e.status] : '-'
          return e
        })
        queryParams.total = total
      })
      .finally(() => {
        loading.value = false
      })
  }

  function open() {
    reset()
    query()
  }

  function reset() {
    for (const k in defaultQueryParams) {
      queryParams[k] = defaultQueryParams[k]
    }
    query()
  }

  function close() {
    emit('close')
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/css/description.scss';
</style>
